import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton TanStack Query client for the admin SPA.
 *
 * Ownership split (ADMIN-10 architectural guardrail):
 *   - TanStack Query owns **server state** (lists, details, queue counts) —
 *     caching, refetch-on-focus, background polling, mutation invalidation.
 *   - MobX (`auth.store`) owns **client/UI state** (current admin, session
 *     lifecycle). The two never duplicate the same datum.
 *
 * Defaults (per ADMIN-PHASE-B-PLAN §3.1):
 *   - `staleTime: 30_000` — list pages stay fresh for 30s; matches the
 *     queue-counts polling cadence so a focus-refetch doesn't double-fire.
 *   - `retry: 1` — one silent retry on transient failure, then surface the
 *     error to the page's error state. Avoids hammering a down API.
 *   - `refetchOnWindowFocus: true` — admin tabbing back to the panel sees
 *     fresh data (mitigates §4.3 stale-pagination drift).
 *
 * Query-key convention: `['admin', '<resource>', 'list', { filters }]`
 * / `['admin', '<resource>', 'detail', id]`. Mutations invalidate by the
 * `['admin', '<resource>']` prefix on success.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
